import Tooltip from '@atlaskit/tooltip';
import { DatabaseFieldType } from '@databases/types/database';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { FIELD_TYPES } from '../field-types/fieldTypes';
export interface FieldTypeIconProps {
  type: DatabaseFieldType;
  noTooltip?: boolean;
}

/**
 * Renders an icon that indicates the specified field type. A tooltip text will describe the field type (unless disabled).
 */
const FieldTypeIcon: FunctionComponent<FieldTypeIconProps> = ({ type, noTooltip }) => {
  const { formatMessage } = useIntl();

  // FIXME: circular dependency introduced by NCTD-2355
  const data = FIELD_TYPES[type];
  const label = formatMessage(data.label);
  const icon = <data.icon label={label} size="small" />;

  if (noTooltip) {
    return icon;
  }

  return (
    <Tooltip tag="span" content={label}>
      {icon}
    </Tooltip>
  );
};

export default FieldTypeIcon;
